document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".blog__navigation li a");
  for (const link of links) {
    if (window.location.pathname === link.pathname) {
      link.closest("li").classList.add("active");
    }
  }
});
